<template>
  <div class="collections">
    <div class="collections__header" v-if="!loading">
      <h1 class="collection__header__title medium-title">{{categoryNameCapitalize  | capitalizing}}</h1>
    </div>
    <div class="collections__main" v-if="!loading">
      <div v-for="(item, index) in collections" :key="index"
        @click.stop="goToCollection(item.id)"
        class="collections__main__content">
        <div class="collections__main__content__thumbnail">
          <img :src="item.square_image" alt="">
        </div>
        <div class="collections__main__content__detail">
          <span class="collections__main__content__detail__subtitle regular-font strong">{{item.title}}</span>
          <p class="collections__main__content__detail__description small-font">
            {{item.description}}
          </p>
        </div>
      </div>
    </div>
    <div v-if="loading" class="collections__loading">
      <adx-loading />
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading/Primary'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { deviceParams, pageParams } from '@/api/params'

export default {
  name: 'adx-collection-category',
  components: {
    'adx-loading': Loading
  },
  props: {

  },
  data() {
    return {
      loading: false,
      collections: [],
      groupId: null,
      title: null
    }
  },
  computed: {
    categoryName() {
      return this.$route.params.category
    },
    categoryNameCapitalize() {
      if (this.title) {
        return `${this.title.charAt(0).toUpperCase() + this.title.substr(1)}`
      }
      return `Collection in ${this.categoryName.charAt(0).toUpperCase() + this.categoryName.substr(1)}`
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    if (deviceParams[this.categoryName] || pageParams[this.categoryName]) {
      this.getCollections()
    } else {
      if (/^[0-9]*$/.test(this.categoryName)){
        this.getCollectionsInGroup()
      } else {
        this.$router.push({ name: '404' })
      }
    }
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getCollections() {
      (async () => {
        this.loading = true
        let response = await api.get(apiV2.collectionCategory(this.categoryName))
        if (response.status == 200) {
          this.collections = response.data
          this.loading = false
        } else {

        }
      })();
    },
    getCollectionsInGroup() {
      (async () => {
        this.loading = true
        let response = await api.get(apiV2.collectionInGroup(this.categoryName))
        if (response.status == 200) {
          this.collections = response.data.collections
          this.title = response.data.title
          this.loading = false
        } else {
          this.$router.push({ name: '404' })
        }
      })();
    },
    goToCollection(id) {
      this.$router.push({ name: 'collectiondetail', params: { id: id } })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>